var map = {
	"./Bar.svg": 276,
	"./Bar_CS.svg": 277,
	"./Bubble.svg": 278,
	"./Bubble_CS.svg": 279,
	"./HorizontalBar.svg": 280,
	"./HorizontalBar_CS.svg": 281,
	"./Line.svg": 282,
	"./Line_CS.svg": 283,
	"./Map.svg": 284,
	"./Map_CS.svg": 285,
	"./Pie.svg": 286,
	"./Pie_CS.svg": 287,
	"./StackedBar.svg": 288,
	"./StackedBar_CS.svg": 289,
	"./Tree.svg": 290,
	"./Tree_CS.svg": 291,
	"./chart-1.png": 490,
	"./chart-2.png": 491,
	"./chart-3.png": 492,
	"./chart-4.png": 493,
	"./chart-5.png": 494,
	"./chart-6.png": 495,
	"./chart-7.png": 496,
	"./coming_soon.png": 497
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 502;


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets nonrecursive \.(png|jpe?g|svg)$
// module id = 502
// module chunks = 0